import { createCustomizations } from '../../context/customizations-provider';

import { componentCustomizations } from './brand-logo.config';

export const customizations = createCustomizations({
  isBrandLogoCasinoLink: false,
  ...componentCustomizations,
});
